@use '../../../../styles/Constants.scss' as Constants;
@use '../../../../styles/Colors.scss' as Colors;

.dropdown-cell {
	width: 100%;
	height: 100% !important;
	max-width: 100%;
	font-size: Constants.$val-fontSizeSmall !important;

	&.bold {
		:global(.dropdown-menu__selected-text) {
			font-weight: bold;
		}
	}

	:global(.dropdown-menu__selected) {
		display: flex;
		align-items: center;
		justify-content: space-between;
		text-align: left;
		cursor: pointer;
	  }
	  
	:global(.dropdown-menu__selected-text) {
		flex: 1 1 auto;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		font-size: Constants.$val-fontSizeSmall !important;
	}
	  
	:global(.dropdown-menu__with-caret) {
		flex: 0 0 auto;
		margin-right: 8px; /* optional spacing from text */
	}



	:global(.dropdown) {
		height: 100% !important;
	}
	:global(.dropup) {
		height: 100% !important;
	}

	:global(.dropdown-toggle) {
		height: 100% !important;
	}

	:global(.dropdown-item) {
		font-size: Constants.$val-fontSizeSmall !important;
	}
	
	:global(.dropdown-toggle--bordered) {
		border-radius: 0% !important;
	}

	:global(.dropdown-toggle.dropdown-toggle) {
		padding: 0 4px !important;
	}

	  
}

.error-wrapper :global(.dropdown ) {
	color: Colors.$col-red !important; 
	background-color: Colors.$col-redBackground !important;
}
.error-wrapper :global(.dropup ) {
	color: Colors.$col-red !important; 
	background-color: Colors.$col-redBackground !important;
}

.error-wrapper :global(.dropdown-toggle__placeholder) {
	color: Colors.$col-red !important; 
}
